import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

const RemoveFromCanvasIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path
        fill="currentColor"
        d="M3.378 2.786L2 4.154l2.203 2.203c-1.02 1.533-1.611 3.367-1.611 5.347 0 5.357 4.347
        9.704 9.704 9.704 1.98 0 3.814-.592 5.347-1.61L19.846 22l1.368-1.368L3.378 2.786zm8.918
         16.681c-4.28 0-7.763-3.483-7.763-7.763 0-1.436.398-2.775 1.087-3.94L16.236
         18.38c-1.165.69-2.504 1.087-3.94 1.087zm-3.94-14.44L6.95 3.612C8.482 2.592 10.316 2
         12.296 2 17.653 2 22 6.347 22 11.704c0 1.98-.592 3.814-1.61 5.347l-1.418-1.417c.69-1.155
         1.087-2.494 1.087-3.93 0-4.28-3.484-7.763-7.763-7.763-1.436 0-2.775.398-3.94 1.087z"
      />
    </IconBase>
  );
};

export default RemoveFromCanvasIcon;
